import { render, staticRenderFns } from "./ServiceManager.vue?vue&type=template&id=2c5f4aaf&"
import script from "./ServiceManager.vue?vue&type=script&lang=js&"
export * from "./ServiceManager.vue?vue&type=script&lang=js&"
import style0 from "./ServiceManager.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports